import { FormikProps } from 'formik/dist/types';
import * as Yup from 'yup';
import {
  ErrorWord,
  CommonData,
  yapStringWhen,
  yapCheckRequiredWhen,
  EstablishPageType,
  yupNumberString,
} from '../common';
import { isEmpty } from 'lodash';

/*--------------
  お客様情報
  --------------*/
//国籍のあれこれ
//リスト名
export enum Nationality {
  JAPAN = '日本',
  USA = '米国',
  OTHER = '日本・米国以外',
}
//{ id: number; value: string }[]のデータ作る
const NationalityList: CommonData[] = (Object.keys(Nationality) as (keyof typeof Nationality)[]).map((key, index) => {
  return { id: index + 1, value: Nationality[key] };
});
//string[]のデータ作る
export const NationalityStrs = NationalityList.map((data) => data.value);
//{ id: number; value: string }[]からリスト名でid取得する
export const finedNationalityId = (str: string) => {
  return NationalityList.find((data) => data.value === str)?.id;
};
//{ id: number; value: string }[]からリスト名でid取得する
export const finedNationalityValue = (id: number) => {
  return NationalityList.find((data) => data.id === id)?.value;
};

//都道府県のあれこれ
//リスト名
enum Prefecture {
  HOKKAIDO = '北海道',
  AOMORI = '青森県',
  IWATE = '岩手県',
  MIYAGI = '宮城県',
  AKITA = '秋田県',
  YAMAGATA = '山形県',
  FUKUSHIMA = '福島県',
  IBARAKI = '茨城県',
  TOCHIGI = '栃木県',
  GUNMA = '群馬県',
  SAITAMA = '埼玉県',
  CHIBA = '千葉県',
  TOKYO = '東京都',
  KANAGAWA = '神奈川県',
  NIIGATA = '新潟県',
  TOYAMA = '富山県',
  ISHIKAWA = '石川県',
  FUKUI = '福井県',
  YAMANASHI = '山梨県',
  NAGANO = '長野県',
  GIFU = '岐阜県',
  SHIZUOKA = '静岡県',
  AICHI = '愛知県',
  MIE = '三重県',
  SHIGA = '滋賀県',
  KYOTO = '京都府',
  OSAKA = '大阪府',
  HYOGO = '兵庫県',
  NARA = '奈良県',
  WAKAYAMA = '和歌山県',
  TOTTORI = '鳥取県',
  SHIMANE = '島根県',
  OKAYAMA = '岡山県',
  HIROSHIMA = '広島県',
  YAMAGUCHI = '山口県',
  TOKUSHIMA = '徳島県',
  KAGAWA = '香川県',
  EHIME = '愛媛県',
  KOCHI = '高知県',
  FUKUOKA = '福岡県',
  SAGA = '佐賀県',
  NAGASAKI = '長崎県',
  KUMAMOTO = '熊本県',
  OITA = '大分県',
  MIYAZAKI = '宮崎県',
  KAGOSHIMA = '鹿児島県',
  OKINAWA = '沖縄県',
}
//{ id: number; value: string }[]のデータ作る
const PrefectureList: CommonData[] = (Object.keys(Prefecture) as (keyof typeof Prefecture)[]).map((key, index) => {
  return { id: index + 1, value: Prefecture[key] };
});
//string[]のデータ作る
export const PrefectureStrs = PrefectureList.map((data) => data.value);
//{ id: number; value: string }[]からリスト名でid取得する

export enum SEX_TYPE {
  'MAN' = 1,
  'WOMAN',
}

export const getSexType = (type: number | null) => {
  switch (type) {
    case SEX_TYPE.MAN:
      return true;
    case SEX_TYPE.WOMAN:
      return false;
    default:
      return undefined;
  }
};

export const getSexTypeStr = (type: number | null) => {
  switch (type) {
    case SEX_TYPE.MAN:
      return '男性';
    case SEX_TYPE.WOMAN:
      return '女性';
    default:
      return undefined;
  }
};

//入力値の型
export type CostomerInfoType = {
  // 国籍
  nationality: string; //Intに変換してリクエスト必要
  // 米国税法上の米国人（米国永住権保持者等）に該当しますか？
  americanOnTaxSystem: boolean | null;
  // SSN (米国社会保障番号)
  ssn: string | null;
  // ITIN (米国納税者番号)
  itin: string | null;
  // FATCAに関する同意
  fatcaAgreement: boolean | null;
  // FATCAに関する宣誓
  fatcaOath: boolean | null;
  // 姓
  firstName: string;
  // 名
  lastName: string;
  // 姓（フリガナ）
  firstNameKana: string;
  // 名（フリガナ）
  lastNameKana: string;
  // 生年月日
  birthday: string; // 形式: yyyy/MM/dd
  // 性別
  sex: number | null;
  // 郵便番号
  postCode: string;
  // 都道府県
  prefecture: string;
  // 市区郡
  cityCounty: string;
  // 町名
  townStreetAddress: string | null;
  // 番地(リクエスト時はtownStreetAddressと結合)
  blockNumber: string | null;
  // 番地なし(リクエストに不要)
  isNoBlockNumber: boolean;
  // 建物名・部屋番号
  buildingNameRoomNumber: string | null;
  // 建物名・部屋番号なし（これはリクエストに不要）
  isNoBuildingNameRoomNumber: boolean;
  // 携帯電話番号
  mobilePhoneNumber: string;
  // 自宅電話番号
  homePhoneNumber: string | null;
  // メールアドレス
  mailAddress: string;
};
//Formik用の型
export type CostomerInfoFormikType = FormikProps<CostomerInfoType>;

//Formikに渡す初期値
export const costomerInfoInitialValues = (param: CostomerInfoType) => {
  return {
    ...param,
    nationality: param.nationality || '',
    americanOnTaxSystem: param.americanOnTaxSystem ?? null,
    ssn: param.ssn ?? null,
    itin: param.itin ?? null,
    fatcaAgreement: param.fatcaAgreement ?? null,
    fatcaOath: param.fatcaOath ?? null,
    firstName: param.firstName || '',
    lastName: param.lastName || '',
    firstNameKana: param.firstNameKana || '',
    lastNameKana: param.lastNameKana || '',
    birthday: param.birthday || '',
    sex: param.sex ?? null,
    postCode: param.postCode || '',
    prefecture: param.prefecture || '',
    cityCounty: param.cityCounty || '',
    townStreetAddress: param.townStreetAddress ?? null,
    blockNumber: param.blockNumber ?? null,
    isNoBlockNumber: param.isNoBlockNumber ?? false,
    buildingNameRoomNumber: param.buildingNameRoomNumber ?? null,
    isNoBuildingNameRoomNumber: param.isNoBuildingNameRoomNumber || false,
    mobilePhoneNumber: param.mobilePhoneNumber || '',
    homePhoneNumber: param.homePhoneNumber ?? null,
    mailAddress: param.mailAddress || '',
  };
};

//バリデーション
//itinチェック用
const yapFatcaJudgeWhen = <T extends Yup.Schema>(yup: T, target: string, errorWord: string) =>
  yup.when(['americanOnTaxSystem', target], {
    is: (check: boolean, str: string) => {
      if (check) {
        return !str;
      }
      return false;
    },
    then: (schema) => schema.required(errorWord),
    otherwise: (schema) => schema.strip(),
  });
export const costomerInfoValidation = (isUpdate: boolean) =>
  Yup.object().shape({
    nationality: Yup.string().required(ErrorWord.SELECT),
    americanOnTaxSystem: Yup.bool().nonNullable(ErrorWord.SELECT),
    ssn: Yup.string()
      .nullable()
      .test('ssn test', ErrorWord.SSN, (ssn, context) => {
        // itinが未入力の場合または入力されている場合は検証する
        if (context.parent.americanOnTaxSystem === true && (!context.parent.itin || !isEmpty(ssn))) {
          if (ssn?.match(/^[0-9]{9}$/)) {
            return true;
          }
        } else {
          return true;
        }
      }),
    itin: Yup.string()
      .nullable()
      .test('itin test', ErrorWord.ITIN, (itin, context) => {
        // ssnが未入力の場合または入力されている場合は検証する
        if (context.parent.americanOnTaxSystem === true && (!context.parent.ssn || !isEmpty(itin))) {
          if (itin?.match(/^[0-9]{9}$/)) {
            return true;
          }
        } else {
          return true;
        }
      }),
    fatcaAgreement: yapCheckRequiredWhen('americanOnTaxSystem', true, ErrorWord.UABLE_OPEN_ACCOUNT),
    fatcaOath: yapCheckRequiredWhen('americanOnTaxSystem', true, ErrorWord.UABLE_OPEN_ACCOUNT),
    firstName: Yup.string()
      .required(ErrorWord.INPUT)
      .matches(/^[^\x20-\x7e]*$/, ErrorWord.INPUT_FULL_WIDTH_CHAR)
      .matches(/^[^\x20-\x7e]|[^ｦ-ﾟ]*$/, ErrorWord.INPUT_FULL_WIDTH_CHAR),
    lastName: Yup.string()
      .required(ErrorWord.INPUT)
      .matches(/^[^\x20-\x7e]*$/, ErrorWord.INPUT_FULL_WIDTH_CHAR)
      .matches(/^[^ｦ-ﾟ]*$/, ErrorWord.INPUT_FULL_WIDTH_CHAR),
    firstNameKana: Yup.string()
      .required(ErrorWord.INPUT)
      .matches(/^[ァ-ヶーＡ-Ｚａ-ｚ０-９　]+$/, ErrorWord.INPUT_FULL_WIDTH_KATAKANA),
    lastNameKana: Yup.string()
      .required(ErrorWord.INPUT)
      .matches(/^[ァ-ヶーＡ-Ｚａ-ｚ０-９　]+$/, ErrorWord.INPUT_FULL_WIDTH_KATAKANA),
    birthday: isUpdate
      ? Yup.date().nullable()
      : Yup.date()
          .min(new Date('1900/1/1').toDateString(), ErrorWord.Date)
          .max(new Date().toDateString(), ErrorWord.Date)
          .required(ErrorWord.INPUT),
    sex: isUpdate ? Yup.number().nullable() : Yup.number().required(ErrorWord.SELECT),
    postCode: yupNumberString({ length: 7, isRequired: true, errorWord: ErrorWord.POSTCODE }),
    prefecture: Yup.string().required(ErrorWord.SELECT),
    cityCounty: Yup.string().required(ErrorWord.INPUT),
    townStreetAddress: Yup.string().required(ErrorWord.INPUT),
    blockNumber: yapStringWhen('isNoBlockNumber', false, ErrorWord.INPUT),
    buildingNameRoomNumber: yapStringWhen('isNoBuildingNameRoomNumber', false, ErrorWord.INPUT),
    mobilePhoneNumber: yupNumberString({ length: 11, isRequired: true, errorWord: ErrorWord.MOBILE_PHONE }),
    homePhoneNumber: Yup.string()
      .nullable()
      .matches(/^[0-9]{10,11}$/gi, ErrorWord.PHONE_NUMBER),
    mailAddress: Yup.string()
      .trim()
      .matches(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/gi, ErrorWord.EMAIL)
      .required(ErrorWord.EMAIL),
  });

//Formikのサブミットメソッド
export const costomerInfoOnSubmit = <T>(param: T, add: (data: T) => void, cb?: () => void) => {
  return (values: CostomerInfoType) => {
    const isAmericanOnTaxSystem = values.americanOnTaxSystem;
    add({
      ...param,
      nationality: values.nationality,
      americanOnTaxSystem: values.americanOnTaxSystem,
      ssn: isAmericanOnTaxSystem ? values.ssn : null,
      itin: isAmericanOnTaxSystem ? values.itin : null,
      fatcaAgreement: isAmericanOnTaxSystem ? values.fatcaAgreement : null,
      fatcaOath: isAmericanOnTaxSystem ? values.fatcaOath : null,
      firstName: values.firstName,
      lastName: values.lastName,
      firstNameKana: values.firstNameKana,
      lastNameKana: values.lastNameKana,
      birthday: values.birthday,
      sex: values.sex,
      postCode: values.postCode,
      prefecture: values.prefecture,
      cityCounty: values.cityCounty,
      townStreetAddress: values.townStreetAddress,
      blockNumber: values.blockNumber,
      isNoBlockNumber: values.isNoBlockNumber,
      buildingNameRoomNumber: values.buildingNameRoomNumber,
      isNoBuildingNameRoomNumber: values.isNoBuildingNameRoomNumber,
      mobilePhoneNumber: values.mobilePhoneNumber,
      homePhoneNumber: values.homePhoneNumber,
      mailAddress: values.mailAddress,
    });
    cb && cb();
  };
};
